import { render, staticRenderFns } from "./InboxCStoPODetail.vue?vue&type=template&id=67922f13&"
import script from "./InboxCStoPODetail.vue?vue&type=script&lang=js&"
export * from "./InboxCStoPODetail.vue?vue&type=script&lang=js&"
import style0 from "./InboxCStoPODetail.vue?vue&type=style&index=0&id=67922f13&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports